import React from 'react';

interface ChartHoverTooltipProps {
  left: number;
  top: number;
  width?: number;
  children: React.ReactNode;
}

/** Floating tooltip over comparison SVG charts. */
export function ChartHoverTooltip({ left, top, width = 160, children }: ChartHoverTooltipProps) {
  return (
    <div
      style={{
        position: 'absolute',
        left,
        top,
        width,
        background: 'rgba(8,11,24,.94)',
        backdropFilter: 'blur(12px)',
        border: '1px solid rgba(255,255,255,.09)',
        borderRadius: 10,
        padding: '9px 11px',
        pointerEvents: 'none',
        boxShadow: '0 8px 24px rgba(0,0,0,.5)',
        zIndex: 30,
        fontSize: 10,
        color: 'rgba(255,255,255,.88)',
        lineHeight: 1.45,
      }}
    >
      {children}
    </div>
  );
}

interface ChartHoverRowProps {
  label: string;
  value: string;
  color?: string;
  bold?: boolean;
}

export function ChartHoverRow({ label, value, color, bold }: ChartHoverRowProps) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, marginTop: 3 }}>
      <span style={{ color: color ?? 'rgba(255,255,255,.55)', fontWeight: bold ? 700 : 600 }}>{label}</span>
      <span style={{ fontWeight: 800, fontVariantNumeric: 'tabular-nums', color: '#fff' }}>{value}</span>
    </div>
  );
}

export function ChartHoverHeader({ children }: { children: React.ReactNode }) {
  return (
    <div
      style={{
        fontSize: 9,
        fontWeight: 800,
        letterSpacing: '0.08em',
        color: 'rgba(255,255,255,.4)',
        marginBottom: 4,
        fontVariantNumeric: 'tabular-nums',
      }}
    >
      {children}
    </div>
  );
}
